module.exports = __webpack_public_path__ + "img/device-4.2ff7c55f.png";